import styled from 'styled-components'

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${props => props.theme.spacing.sp4};
  margin-bottom: ${props => props.theme.spacing.sp8};
`
export const ExchangeTitle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: ${props => props.theme.spacing.sp16};
`

export const RefundQuantity = styled.p`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp4};
  margin-top: ${props => props.theme.spacing.sp16};
  margin-bottom: ${props => props.theme.spacing.sp16};
  color: ${props => props.theme.colors.text.default};
  font-size: ${props => props.theme.texts.bodyMRegular.fontSize};
  font-family: ${props => props.theme.texts.bodyMRegular.fontFamily};
`
